// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__SQLpO","linkCollection":"footer_linkCollection__WD9iB","header":"footer_header__a2hjA"};